<template lang="pug">
.time-coupons-container(:class='{ "new-module": newModule }')
  .time-block(v-if='times && times.length', :class='["num-" + times.length]')
    .time-block-item.flex-mid(
      v-for='(item, index) in times',
      :class='{ active: active === index }',
      @click='changeTime(index)'
    )
      .time {{ item.time }}
      .text {{ item.text }}
  .count-down.flex-mid(v-if='newModule && countdown.data.length')
    .desc 火热抢购中，先抢先得
    template(v-if='countdown.time[active] && !countdown.time[active].length')
      .count
        span 距离结束
        .count-item(v-for='(item, index) in countdown.data', :key='index')
          span {{ item }}
    template(v-else)
      .count {{ countdown.time[active] }}
  .coupons
    template(v-if='part[active] && part[active].length > 0')
      .coupon-item(v-for='(item, index) in coupons2show')
        template(v-if='newModule')
          .tip(v-if='item.status === TIME_COUPON_STATUS.DOUBLE')
            span 膨胀后可升级为
            span {{ item.swellPriceV2[0].value }}
            span {{ item.swellPriceV2[0].unit }}
            span {{ item.swellOfferType === MARKET_OFFER_TYPE.CARD ? "卡" : "优惠券" }}
            span ，建议立即膨胀
          CardCouponsItemNew(
            :class='{ top: newModule && item.status === TIME_COUPON_STATUS.DOUBLE }',
            :info='item',
            :btnIndex="index",
            @btn='clickCoupon(item, index)',
            @use='use(item)'
          )
        template(v-else)
          CardCouponsItem(
            :info='item',
            @btn='clickCoupon(item, index)',
            @use='use(item)'
          )
    template(v-else)
      Empty
  .more.flex-mid(
    v-if='part[active] && part[active].length > 3 && !more[active]',
    @click='seeMore'
  )
    span 更多秒杀券
    .common-arrow-down
  DoubleModal(ref='modal', @confirm='double', @cancel='cancelDouble')
  DoubleModalType(ref='modalType', @confirm='confirm', @cancel='cancel')
</template>

<script>
import Toast from '@/components/toast';
import Empty from '@/components/empty';
import { env, Native } from '@hb/NBridge/lib/h5';
import { marketDistribute } from '@/api/card';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { startApp } from '@/utils/index';
import config from '@/const/config';
import CardCouponsItem from './card-coupon-item';
import CardCouponsItemNew from './card-coupon-item-new';
import DoubleModal from './double-modal';
import { getTokenAndKey } from '../../../utils';
import {
  CARD_COUPON_TYPE,
  PART_STATUS,
  PART_TEXT,
  TIME_COUPON_STATUS,
  MODAL_MODULE_TYPE,
} from '../consts';
import {
  doubleMarketCoupon,
  handleClickCoupon,
  handleMarketCoupons,
  welfareGoCoupon,
  formatDuration,
} from '../utils';
import DoubleModalType from './double-modal-type.vue';
import { MARKET_OFFER_TYPE } from '../../../const';

const APP_OPEN_LINK = 'https://m.hellobike.com/ebike-h5/latest/index-3.html#/activity/common?guid=ce8d4dc4760945588d3c8411d3f6ba70&beyondMP=true';

export default {
  components: {
    CardCouponsItem,
    Empty,
    DoubleModal,
    DoubleModalType,
    CardCouponsItemNew,
  },
  props: {
    activity: {
      type: Object,
      default: null,
    },
    newModule: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      times: [],
      PART_STATUS,
      active: 1,
      part: [],
      more: [],
      MARKET_OFFER_TYPE,
      countdown: {
        time: [],
        timer: null,
        second: null,
        data: [],
      },
      TIME_COUPON_STATUS,
    };
  },
  computed: {
    coupons2show() {
      if (
        this.part[this.active]
        && this.part[this.active].length > 3
        && !this.more[this.active]
      ) {
        return this.part[this.active].slice(0, 3);
      }
      return this.part[this.active];
    },
  },
  watch: {
    coupons2show: {
      deep: true,
      handler(curVal) {
        (curVal || []).forEach((item) => {
          UBT.moduleExpose({
            pageId: 'Welfare',
            categoryId: 'platform',
            moduleId: 'coupon_state',
            contentId: 'coupon_state',
            exposureTimes: 1,
            businessInfo: {
              coupon_state: item.status || '未知',
              coupon_name: item.title,
              Sessions: item.time,
              activity: item.type === CARD_COUPON_TYPE.TIME_COUPON ? '0' : '1',
            },
          });
        });
      },
    },
  },
  mounted() {},
  methods: {
    seeMore() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'more_coupon',
        categoryId: 'platform',
        businessInfo: {
          activity: '0',
        },
      });
      this.$set(this.more, this.active, true);
    },
    changeTime(index) {
      this.active = index;
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'platform_Sessions',
        categoryId: 'platform',
        businessInfo: {
          Sessions: this.times[index].time,
        },
      });
    },
    use(item) {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'use_go',
        categoryId: 'platform',
        businessInfo: {
          coupon_name: item.tile,
          activity: '0',
          Sessions: this.times[this.active].time,
          use: '1',
        },
      });
      if (item.offerType === MARKET_OFFER_TYPE.COUPON) {
        welfareGoCoupon();
      } else {
        this.goCard();
      }
    },
    goCard() {
      Native.callNative({
        method: 'goOperationUrlV2',
        params: `https://m.hellobike.com/AppHelloBikeMainH5/${config.envUrlMixin}latest/index.html#/my-cards?adsource=welfare`,
      });
    },
    cancelDouble(item) {
      this.$refs.modalType.open(
        Object.assign(item, { type: MODAL_MODULE_TYPE.CANCEL }),
      );
    },
    clickCoupon(item) {
      if (
        item.status === TIME_COUPON_STATUS.USE
        || item.status === TIME_COUPON_STATUS.GO_USE
      ) {
        UBT.clickButton({
          pageId: 'Welfare',
          buttonName: 'use_go',
          categoryId: 'platform',
          businessInfo: {
            coupon_name: item.tile,
            activity: '0',
            Sessions: this.times[this.active].time,
            use: '0',
          },
        });
        if (item.offerType === MARKET_OFFER_TYPE.COUPON) {
          welfareGoCoupon();
        } else {
          this.goCard();
        }
        return;
      }
      const text = item.offerType === MARKET_OFFER_TYPE.CARD ? '骑行卡' : '券';
      if (
        this.times[this.active]
        && this.times[this.active].status === PART_STATUS.END
      ) {
        if (item.status === TIME_COUPON_STATUS.GRAB) {
          Toast.show('本场次活动已结束~');
          return;
        }
        if (item.status === TIME_COUPON_STATUS.DOUBLE) {
          Toast.show(`本场次膨胀活动已结束，请直接使用${text}哦～`);
          return;
        }
      }
      if (item.status === TIME_COUPON_STATUS.NONE) {
        Toast.show(`很遗憾，${text}已被领完`);
        return;
      }
      if (
        this.times[this.active]
        && this.times[this.active].status === PART_STATUS.NOT
      ) {
        Toast.show('活动暂未开始');
        return;
      }
      if (item.status === TIME_COUPON_STATUS.DOUBLE) {
        this.$refs.modal.open({ item });
        return;
      }
      handleClickCoupon(this.activity, item, {
        type: CARD_COUPON_TYPE.TIME_COUPON,
        time: this.times[this.active].time,
      }).then(() => {
        this.getData(false);
        this.$emit('coupon');
      });
    },
    // 膨胀
    double({ item }) {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'expand_go',
        categoryId: 'platform',
        businessInfo: {
          coupon_name: item.title,
          Sessions: this.times[this.active].time,
          activity: '1',
        },
      });

      doubleMarketCoupon(this.activity, item.detail)
        .then(() => {
          this.getData(false);
          this.$refs.modalType.open(
            Object.assign(item, { type: MODAL_MODULE_TYPE.SUCCESS }),
          );
        })
        .catch((e) => Toast.showError(e));
    },
    async getData(refreshIndex = true) {
      if (!this.activity) {
        return Promise.resolve();
      }
      const { activityCode, componentKey } = this.activity;
      const { token } = await getTokenAndKey();
      const data = await marketDistribute({
        activityCode,
        token,
        channelId: env.platformCode,
        methodName: 'matchPeriodSwellPrize',
        param: JSON.stringify({ activityCode, componentKey }),
      })
        .then((v) => v.data || [])
        .catch(() => []);
      if (!data.length) {
        this.$emit('showModule');
        return Promise.resolve();
      }
      const { part, times } = data.reduce(
        (res, cur) => {
          const {
            periodStartTime: startTime,
            prizeMatchDetails,
            periodStatus,
          } = cur;
          res.times.push({
            time: startTime,
            status: periodStatus,
            text: PART_TEXT[periodStatus],
          });
          UBT.moduleExpose({
            pageId: 'Welfare',
            categoryId: 'platform',
            moduleId: 'platform_Sessions',
            contentId: 'platform_Sessions',
            exposureTimes: 1,
            businessInfo: {
              Sessions: startTime,
            },
          });
          res.part.push(
            handleMarketCoupons(prizeMatchDetails, {
              type: CARD_COUPON_TYPE.TIME_COUPON,
              periodStatus,
              time: startTime,
              newModule: this.newModule,
            }),
          );
          res.times.forEach((x, index) => {
            if (x.status === '1' && res.part[index].length < 1) {
              this.$emit('showModule', false);
            }
          });
          return res;
        },
        {
          part: [],
          times: [],
        },
      );
      this.times = times;
      this.part = part;

      // 新模块，倒计时
      if (this.newModule) {
        this.countdown.time = data.map((v) => {
          if (v.countdown && v.countdown > 0) {
            this.countdown.second = v.countdown;
            clearInterval(this.countdown.timer);
            this.countdown.timer = setInterval(
              () => this.updateCountdown(),
              1000,
            );
            return [];
          }
          return `${v.periodStartTime}点开抢`;
        });
      }

      if (refreshIndex) {
        const index = this.times.findIndex((v) => v.status === PART_STATUS.GOING);
        if (typeof index === 'number' && index !== -1) {
          this.active = index;
        } else {
          this.active = 0;
        }
      }
      return Promise.resolve();
    },
    updateCountdown() {
      if (this.countdown.second <= 0) {
        clearInterval(this.countdown.timer);
        this.getData();
        return;
      }
      const { hours, minutes, seconds } = formatDuration(
        this.countdown.second * 1000,
      );
      this.countdown.second -= 1;
      this.countdown.data = [hours, minutes, seconds];
    },
    confirm(item) {
      if (item.type === MODAL_MODULE_TYPE.SUCCESS) {
        if (env.isAliMP || env.isAliMPMonitor) {
          startApp(APP_OPEN_LINK);
        } else {
          window.location.href = APP_OPEN_LINK;
        }
        this.getData(false);
      } else {
        // 继续膨胀
        this.$refs.modal.open(item);
      }
    },
    cancel() {
      this.getData(false);
    },
  },
};
</script>

<style lang="less" scoped>
.time-coupons-container {
  display: flex;
  flex-direction: column;

  .time-block {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.13rem;

    .time-block-item {
      flex-direction: column;
      width: 0.86rem;
      height: 0.42rem;
      background: #f7f9fa;
      border-radius: 0.07rem;
      color: #5a6066;

      .time {
        font-size: 0.16rem;
        font-family: 'DIN Alternate Bold', sans-serif;
        font-weight: bold;
      }

      .text {
        font-size: 0.12rem;
      }

      &.active {
        background: #ffece6;
        color: #f72626;

        .text {
          font-weight: 600;
        }
      }
    }

    &.num-4 .time-block-item {
      width: 0.74rem;
    }
  }

  .coupons {
    display: flex;
    flex-direction: column;

    .coupon-item {
      position: relative;

      &:not(:last-of-type) {
        margin-bottom: 0.12rem;
      }

      .tip {
        position: absolute;
        width: 3.15rem;
        font-weight: 400;
        color: #ee8c02;
        line-height: 0.12rem;
        font-size: 0.12rem;
        background: #fff5e3;
        border-radius: 0.08rem 0.08rem 0 0;
        padding: 0.07rem 0.1rem 0.14rem 0.08rem;
        margin-left: 0.02rem;
      }

      .top {
        margin-top: 0.22rem;
      }
    }
  }

  .more {
    font-size: 0.12rem;
    color: #999;
    margin-top: 0.16rem;

    .common-arrow-down {
      border-color: #999;
    }
  }

  &.new-module {
    .time-block {
      .time-block-item {
        flex-direction: row;
        width: 1rem;
        height: 0.36rem;
        color: #242729;

        .time {
          margin-right: 0.04rem;
          font-weight: 600;
        }

        .text,
        .time {
          margin-top: 0.01rem;
        }

        &.active {
          background: #ffeee9;
          color: #ff5526;

          .text {
            font-weight: 600;
          }
        }
      }
    }

    .count-down {
      justify-content: space-between;
      margin-bottom: 0.19rem;
      color: #242729;
      font-size: 0.12rem;
      font-weight: 400;
      height: 0.15rem;

      .desc {
        line-height: 0.15rem;
      }

      .count {
        display: flex;
        line-height: 0.12rem;
        justify-content: center;
        align-items: center;

        .count-item {
          padding: 0.05rem 0.03rem 0.04rem;
          background: #242729;
          border-radius: 0.03rem;
          color: #fff;
          line-height: 0.09rem;
          font-size: 0.1rem;
          margin-left: 0.08rem;
          position: relative;

          &:not(:last-of-type) {
            &::after {
              right: -0.065rem;
              content: ':';
              position: absolute;
              color: #5a6066;
              width: 0.04rem;
              font-weight: 500;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }

        :nth-child(2) {
          margin-left: 0.04rem;
        }
      }
    }
  }
}
</style>
